import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI, {Message} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

// 1. 引入你需要的组件
import vant from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';
Vue.config.productionTip = false
Vue.use(ElementUI,{size: 'small', zIndex: 3000});
Vue.use(vant);
// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
// 全局修改默认配置，按下ESC不能关闭弹窗
ElementUI.Dialog.props.closeOnPressEscape.default = false

Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'



axios.interceptors.request.use((config) => {
    config.headers.token = localStorage.getItem('token');
    return config;
});

axios.interceptors.response.use(response => {
    if (response.data.code === 400) {
        Message.error({message: response.data.msg})
    } else if (response.data.code === 401) {
        Message.error({message: '登录信息已失效，请重新登录'})
        window.localStorage.removeItem('id')
        window.localStorage.removeItem('username')
        window.localStorage.removeItem('token')
        router.push('/')
    }
    return response
}, function (error) {
    if (error.message.includes('500')) {
        Message.error({message: '服务器连接失败'})
    }
    if (error.message.includes('404')) {
        Message.error({message: '请求接口不存在'})
    }
})

new Vue({
    router, store, render: h => h(App)
}).$mount('#app')
